import React from 'react'
function Season() {
  return (
    <div className='container py-5'>
     <div >
        <div className='row'>
          <div className='col-lg-6 mb-sm-3'>
            <div className='seasontop'>
            <img className='w-100' src={require('../images/shop.jpg')}/>
            <div className='season text-end'>
              <h3 className=' fw-bold'>New Season</h3>
              <h4 className='fs-5 py-2'>Sale 40% Off</h4>
              <a href="/" className='shop'>SHOP NOW</a>
            </div>
          </div>    
         </div>
         <div className='col-lg-6'>
            <div className='seasontop'>
            <img className='w-100' src={require('../images/shop1.jpg')}/>
            <div className='season text-end'>
              <h4 className='fs-5'>Super Sale</h4>
              <h3 className='fw-bold py-2'>New Collection</h3>
              <a href="/" className='shop'>SHOP NOW</a>
            </div>
          </div>    
         </div>
        </div>
    </div> 
    </div>
  )
}

export default Season
